import { NAME } from './constants';

export const INFO = `${NAME}/INFO`;
export const SUCCESS = `${NAME}/SUCCESS`;
export const WARNING = `${NAME}/WARNING`;
export const ERROR = `${NAME}/ERROR`;
export const CLOSE = `${NAME}/CLOSE`;
export const STICK = `${NAME}/STICK`;
